export const headerZh = {
  tabs: {
    home: '首页',
    project: '项目活动',
    Plaza: '内容专区',
    tasks: '活动任务',
    planet: '成长星球',
    teamHome: '团队主页',
    pictrues: '精彩图集',
    messages: '活动消息',
    toCoach: '进入教练端',
    loginOrRes: '登录/注册',
    myActivities: '我的活动',
    experienceMode: '体验模式',
    studentMode: '学生模式'
  },
  mine: {
    home: '我的主页',
    society: '俱乐部',
    activity: '活动中心',
    orders: '订单中心',
    Myorders: '我的订单',
    coupons: '我的优惠券',
    setting: '账号管理',
    quite: '退出',
    info: '个人资料',
    account: '账号设置',
    authenticationCenter: '认证中心',
    myBadges: '我的徽章',
    battleCenter: '极速抢答',
    messageUs: '留言咨询'
  },
  footerWords: {
    t1: '服务与支持',
    t2: '隐私政策',
    t3: '用户协议',
    t4: '联系我们',
    t5: '关于Bloom',
    t6: '关于我们',
    t7: '切换语言',
    t8: '关注我们',
    t9: '微信公众号',
    t10: '微信小程序',
    t11: '特此声明：本平台相关活动以培养德智体美全面发展的社会主义建设者和接班人为宗旨，为每一位参与学生提供链接真实社会与行业的学术及素养能力实践研习机会，并在研习过程中收获成长和走向社会所需要的能力。本活动对学生的研习过程进行记录，对活动的结果予以综合性评价，属于专业社会实践活动范畴，非竞赛属性。相关研习成绩认证、报告、荣誉得到海外权威学术机构与相关大学的认可，不与国内中小学升学挂钩',
    t12: '求助'
  },
  battle: {

  }
}

export const headerEn = {
  tabs: {
    home: 'Home',
    project: 'Projects and Activities',
    Plaza: 'Events Plaza',
    tasks: 'Activity Tasks',
    planet: 'Community',
    teamHome: 'Team Home Page',
    pictrues: 'Highlights',
    messages: 'Messages',
    toCoach: 'Coach',
    loginOrRes: 'Log In | Sign Up',
    myActivities: 'My Activities',
    experienceMode: 'Experience mode',
    studentMode: 'Student mode'
  },
  mine: {
    home: 'My Home',
    society: 'My School Club',
    activity: 'My Activities',
    orders: 'My Order',
    Myorders: 'My Order',
    coupons: 'My Coupons',
    setting: 'Setting',
    quite: 'Exit',
    info: 'Personal Information',
    account: 'Account Setting',
    authenticationCenter: 'Authentication',
    myBadges: 'My Badges',
    battleCenter: 'Battle Center',
    messageUs: 'Message Us'
  },
  footerWords: {
    t1: 'Service and Support',
    t2: 'Privacy Policy',
    t3: 'User Agreement',
    t4: 'Contact Us',
    t5: 'Bloom Introduce',
    t6: 'About Us',
    t7: 'Language',
    t8: 'Follow Us',
    t9: 'Wechat',
    t10: 'Mini Program',
    t11: 'It is hereby certified, all activities are not linked with the entrance of junior&senior high school',
    t12: 'Help'
  },
  battle: {

  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/header/index.js